document.addEventListener('DOMContentLoaded', function () {
    function kapaiShippingDomRemove() {
        const checkBox = document.querySelector('.watt-cart__below-subtotal-kapai');
        if(checkBox) {
            const allLine = document.querySelectorAll('.watt-cart__item');
            if(allLine && allLine.length > 0) {
                let showCheckboxFlag = false
                const keysData = checkBox.getAttribute('data-keys')
                if(!keysData) return
                const keys = keysData.split(';')
                for (const item of allLine) {
                    const lineKey = item.getAttribute('data-key')
                    if(!lineKey) continue
                    if (keys.includes(lineKey)) {
                        showCheckboxFlag = true
                        break
                    }
                }
                if(!showCheckboxFlag) {
                    checkBox.remove()
                }
            }
        }
    }

    document.addEventListener('watt:cart:remove:row', function () {
        kapaiShippingDomRemove()
    })
})